import Vue from "vue";
import App from "./App.vue";
import router from "./routes/index";
import * as firebase from "firebase";
import store from "./store";

Vue.config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyD_R70-Mll55cELNeDb2HlNhXgURbPtiNQ",
  authDomain: "sports-scores-67601.firebaseapp.com",
  databaseURL: "https://sports-scores-67601.firebaseio.com",
  projectId: "sports-scores-67601",
  storageBucket: "sports-scores-67601.appspot.com",
  messagingSenderId: "963985529774",
  appId: "1:963985529774:web:25071bce1a6f0b16e2063f",
  measurementId: "G-7EJYP8BLDP"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");